import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { SubscriptionPlans } from '@/components/subscription/SubscriptionPlans';

const Subscription = () => {
  useEffect(() => {
    // SEO basics
    document.title = 'MindNote Pro Subscription Plans';

    const metaDesc = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDesc.setAttribute('name', 'description');
    metaDesc.setAttribute('content', 'Choose your MindNote Pro subscription plan for iOS. Monthly or yearly.');
    if (!metaDesc.parentNode) document.head.appendChild(metaDesc);

    const canonical = document.querySelector('link[rel="canonical"]') || document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', window.location.origin + '/subscription');
    if (!canonical.parentNode) document.head.appendChild(canonical);
  }, []);

  const isIOS = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';

  return (
    <main className="max-w-5xl mx-auto p-6 space-y-6">
      <header>
        <h1 className="text-3xl font-bold">MindNote Pro Subscription Plans</h1>
        <p className="text-muted-foreground">Subscribe on iOS to unlock all premium features.</p>
      </header>
      <section aria-labelledby="plans-heading">
        <h2 id="plans-heading" className="sr-only">Plans</h2>
        <SubscriptionPlans />
        {!isIOS && (
          <p className="text-sm text-destructive mt-4">Subscriptions are available on the iOS app. Please install and open MindNote on your iOS device.</p>
        )}
      </section>
    </main>
  );
};

export default Subscription;
